import { StoreDetailFragmentApi } from 'graphql/generated';
import { StoreDetailType } from 'types/store';

export const mapStoreDetailApiData = (data: StoreDetailFragmentApi): StoreDetailType => {
    return {
        ...data,
        __typename: 'Store',
        acceptGiftCouponIcon: data.acceptGiftCouponIcon === null ? null : data.acceptGiftCouponIcon,
        hasLoyaltyProgramIcon: data.hasLoyaltyProgramIcon === null ? null : data.hasLoyaltyProgramIcon,
        isPickupPointIcon: data.isPickupPointIcon === null ? null : data.isPickupPointIcon,
        locationLatitude: data.locationLatitude !== null ? Number.parseFloat(data.locationLatitude) : null,
        locationLongitude: data.locationLongitude !== null ? Number.parseFloat(data.locationLongitude) : null,
    } as StoreDetailType;
};
